import { Button, Flex } from "antd";
import { DividerThin } from "../../../../../shared";
import { isAndroid, isIOS } from "react-device-detect";

interface IProps {
    date?: string
    totalBookingCnt?: number
    totalBookingPrice?: number
    onClickBookingBtn: Function
    disabled?: boolean
    style?: React.CSSProperties
    text?: string
}

const BookingSecondStepFooter = ({ date, totalBookingCnt, totalBookingPrice, onClickBookingBtn, disabled, style, text }: IProps) => {
    return <>
        <div style={{ height: isIOS ? 'calc(91px + 46px + 40px)' : isAndroid ? 'calc(91px + 24px + 40px)' : 'calc(91px + 40px)' }}></div>
        <div style={{ position: "fixed", bottom: "0", width: "100%", maxWidth: "480px", backgroundColor: 'white', zIndex: 1, ...style }}>
            <DividerThin style={{ height: '1px' }} />
            <Flex gap={16} style={{ padding: '12px 20px 20px' }}>
                <div style={{ flex: 1 }}>
                    <div className="body/b2" style={{ marginBottom: 4 }}>{date ?? '날짜 미선택'}</div>
                    {totalBookingCnt !== null && totalBookingCnt !== undefined && <div className="body/b2">{totalBookingCnt}명</div>}
                    {totalBookingPrice !== null && totalBookingPrice !== undefined && <div className="sub-title/st3">{totalBookingPrice?.toLocaleString()}원</div>}
                </div>
                <div style={{ flex: 1 }}>
                    <Button disabled={disabled} onClick={() => onClickBookingBtn()} variant="solid" color="default" style={{ width: '100%', height: 51, border: 'none', backgroundColor: disabled ? 'var(--secondarys200)' : '' }}>
                        <div className="sub-title/st3">
                            {text ? text : '신청하기'}
                        </div>
                    </Button>
                </div>
            </Flex>
            {(isIOS) && <div style={{ height: '46px', backgroundColor: 'transparent', width: '100%' }} />}
            {(isAndroid) && <div style={{ height: '24px', backgroundColor: 'transparent', width: '100%' }} />}
        </div >
    </>
}

export default BookingSecondStepFooter;